import { useParams } from 'react-router-dom';
import { findBlogTopic } from '../../lib/blogTopics';
import Blog from './Blog';
import BlogDetails from '../BlogDetail/BlogDetails';
export default function BlogTopicRoute() {
  const {slug} = useParams();
  return findBlogTopic(slug) ? <Blog /> : <BlogDetails />;
}
